import React from 'react';
import { StyleSheet } from './style_sheet';
import { ScrollView } from './views';

const styles = StyleSheet.create({
  flatList: {
    flexDirection: 'column',
  },
  innerList: {
    flex: 1,
    alignSelf: 'stretch',
    flexDirection: 'column',
  },
  innerListInverted: {
    flex: 1,
    alignSelf: 'stretch',
    flexDirection: 'column-reverse',
  },
});

export function FlatList(props: any) {
  const { data, inverted, renderItem, contentContainerStyle } = props;
  const keyExtractor = props.keyExtractor ?? _keyExtractor;
  const ListHeaderComponent = props.ListHeaderComponent ?? null;
  const ListEmptyComponent = props.ListEmptyComponent ?? null;
  const ListFooterComponent = props.ListFooterComponent ?? null;
  const inner_style = inverted ? styles.innerListInverted : styles.innerList;
  const elements =
    data?.length > 0
      ? data.map((item: any, index: any) => {
          const obj = renderItem({
            item,
            index,
            separators: {
              highlight: _noop,
              unhighlight: _noop,
              updateProps: _noop,
            },
          });
          const key = keyExtractor(item, index);
          return <React.Fragment key={key}>{obj}</React.Fragment>;
        })
      : ListEmptyComponent;

  return (
    <ScrollView
      style={[styles.flatList, props.style]}
      contentContainerStyle={[contentContainerStyle, inner_style]}
    >
      {ListHeaderComponent}
      {elements}
      {ListFooterComponent}
    </ScrollView>
  );
}
function _keyExtractor(item: any, index: any) {
  return item.key ?? index;
}
function _noop() {}
